/**
 * Stub implementation for @babel/runtime/helpers/callSuper
 * This helper is used by packages like @antv/g-* and antd.
 *
 * Signature: _callSuper(derived, parent, args)
 * - derived: the derived class instance (this)
 * - parent: the parent class constructor or method
 * - args: array of arguments to pass
 */
function _getPrototypeOf(t) {
    return Object.setPrototypeOf
        ? Object.getPrototypeOf(t)
        : t.__proto__ || Object.getPrototypeOf(t);
}

function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {}),
        );
        return true;
    } catch (e) {
        return false;
    }
}

function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
    }
    if (call !== void 0) {
        throw new TypeError(
            "Derived constructors may only return object or undefined",
        );
    }
    return self;
}

function _callSuper(t, o, e) {
    o = _getPrototypeOf(o);
    return _possibleConstructorReturn(
        t,
        _isNativeReflectConstruct()
            ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor)
            : o.apply(t, e),
    );
}

module.exports = _callSuper;
module.exports.__esModule = true;
module.exports["default"] = module.exports;
